import React, { FC, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router5';

import { Button, Header, Placeholder } from '$uikit';
import { IcFailed72 } from '$assets';
import { useTranslator } from '$hooks';
import { authSelector } from '$store/auth';
import { AuthRequired } from '$core/AuthRequired/AuthRequired';
import { FEED } from '$shared/constants/pages';
import { statReachGoal } from '$utils';

export const SubscriptionFailed: FC = () => {
  const { isLogged } = useSelector(authSelector);
  const t = useTranslator();

  useEffect(() => {
    statReachGoal('payment_failed');
    statReachGoal('buy_subscription_failed');
  }, []);

  if (!isLogged) {
    return <AuthRequired />;
  }

  return (
    <>
      <Header />
      <Placeholder
        centered
        title={t('subscription_failed_title')}
        iconSize={72}
        icon={<IcFailed72 color="var(--tint-negative)" />}
        actions={
          <Link routeName={FEED}>
            <Button size="small">{t('go_to_home')}</Button>
          </Link>
        }
      >
        {t('subscription_failed_caption')}
      </Placeholder>
    </>
  );
};
